import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceSelectStoreLanguageRenderComponent } from './render/piece-select-store-language-render.component';


export const pieceSelectStoreLanguageRenderModuleEntryComponents = [
  PieceSelectStoreLanguageRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    RouterModule
  ],
  declarations: pieceSelectStoreLanguageRenderModuleEntryComponents
})
export class PieceSelectStoreLanguageRenderModule {}

export default pieceSelectStoreLanguageRenderModuleEntryComponents;
